export default {"src":"/_next/static/media/icon-right.298a3544.svg","height":13,"width":8};